import React, { useMemo } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { track } from '@utils';
import { CLICK_CHART_TOOL } from '@src/utils/sensor/track';
import { annotationAtom } from '@src/atoms/toggles';
import { annotationsFeatureSelector } from '@store/common/selectors';
import { StyledActionsLabel, StyledActionsWrapper, ToolbarWrapper } from './styled';
import useContainerRef from '@src/hooks/utils/useContainerRef';

export enum TOOLS {
  zoom = 'zoom',
  select = 'select',
  annotate = 'annotate',
  zoomToSelect = 'zoom-to-select',
  noTool = 'no-tool',
}

function Toolbar({ activeTool, setActiveTool }) {
  const annotationsToggled = useAtomValue(annotationAtom);
  const isAnnotationEnabled = useSelector(annotationsFeatureSelector) && annotationsToggled;
  const { containerRef, getContainer } = useContainerRef();

  const handleChange = (value) => {
    track({
      event: CLICK_CHART_TOOL,
      data: { activeTool: value },
    });
    setActiveTool(value);
  };

  const options = useMemo(() => {
    return [
      { label: 'Zoom', value: TOOLS.zoom },
      { label: 'Slice', value: TOOLS.select },
      { label: 'Zoom & Slice', value: TOOLS.zoomToSelect },
      { label: 'Annotate', value: TOOLS.annotate, disabled: !isAnnotationEnabled },
    ];
  }, [isAnnotationEnabled]);

  return (
    <StyledActionsWrapper ref={containerRef}>
      <StyledActionsLabel>Actions</StyledActionsLabel>
      <Select
        value={activeTool}
        bordered={false}
        onChange={handleChange}
        options={options}
        dropdownStyle={{ minWidth: 150 }}
        getPopupContainer={getContainer}
      />
    </StyledActionsWrapper>
  );
}

export default Toolbar;
